// 实时接收消息推送
// Vue.prototype.resetSerItem = function(key, newValue) {
// 	if(key === 'watchStorage') {
// 		var newStorageEvent = document.createEvent('StorageEvent');
// 		const storage = {
// 			setItem: function(k, val) {
// 				sessionStorage.setItem(k, val);
				
// 				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val ,null, null);
				
// 				window.dispatchEvent(newStorageEvent);
// 			}
// 		}
// 		return storage.setItem(key, newValue);
// 	}
// }

export default({
  init() {
    if (typeof(WebSocket) === "undefined") {
      alert("您的浏览器不支持socket，建议您更换浏览器");
    } else {
      this.socket = new WebSocket("wss://msgproject.ichuk.com/ichukMsg?appid=4058a40ebcc0498ab7b9ef19bafe814d&uid=0002");
      this.socket.onopen = this.open;
      this.socket.onerror = this.error;
      this.socket.onmessage = this.getMessage
    }
  },
  open() {
  },
  error() {
  },
  getMessage(msg) {
    this.resetSerItem('watchStorage',msg.data);
  },
  send() {
    this.socket.send("test");
  },
  close() {
  }
})